import { api } from 'shared';
import { z } from 'zod';

export const AwardsResponseSchema = z.object({
    data: z.array(
        z.object({
            documentId: z.string(),
            slug: z.string(),
            name: z.string(),
            description: z.any().optional().nullable(),
            image: z.object({
                url: z.string(),
            }).optional().nullable(),
            years: z.array(
                z.object({
                    year: z.string(),
                }),
            ).optional().nullable(),
        }),
    ),
});
export const fetchAwards = async () => (
    api.get<z.infer<typeof AwardsResponseSchema>>(
        '/awards',
        {
            populate: {
                image: {
                    fields: 'url',
                },
                years: {
                    fields: '*',
                },
            },
        },
        AwardsResponseSchema,
    )
);
